import SeoHead from "../../components/SeoHead";
import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import "@sourceflow-uk/job-search/dist/bundle.css";
import SubBanner from "../../components/SubBanner";
import JobSearch from "../../components/AllJobs";
import Header from "../../components/MainHeader";

export default function jobSearchIndex({ global, sectorIds }) {
  return (
    <>
      <SeoHead
        // site_name={`Driving Force`}
        page_name={`Internal Jobs Search | Gap Personnel`}
        // description={`Check out all of our driving jobs including HGV vacancies. If you are looking for full-time, part-time or temporary driving jobs please contact us today.`}
        canonical_link={`/jobs/internal/`}
      />
      <Header employerNav={false} />
      <SubBanner
        global={global}
        pathPrefix={`internal_job_search_page.sub_banner`}
        customClass={`mb-5 secondary-banner`}
        buttonTitle={`Job search`}
        buttonLink={``}
        heading={`Internal Jobs Search`}
        bannerImage="/site-assets/images/job-search-banner.jpg"
        bannerImageAlt="Driving Force Job Search Banner"
      />
      <JobSearch
        customClass={`pt-md-5 pb-md-5`}
        sectorIds={sectorIds}
        internalJob={true}
      />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = await Global();
  //For filtering jobs search with sectors
  const sector = await Collection("specialisms");
  // const sectorIds = sector.map('id').getItems()
  const sectorIds = sector
    //Exclude from getting Recruitment Sector value
    // .filter(item => item.id !== '2400a212-abe4-4e55-a0dd-8763dc6140fa')
    .map((item) => item.id)
    .getItems();
  return {
    props: {
      global: global.toJson(),
      sectorIds,
    },
  };
}
